import { AUTH_HEADERS } from '../core/src';

export const sharedSentryReplayIntegrationConfig = {
    maskAllText: false,
    blockAllMedia: false,
    mask: ['.sentry-mask, [data-sentry-mask]'],
    block: ['.sentry-block, [data-sentry-block]'],
    networkDetailAllowUrls: [window.location.origin],
    networkRequestHeaders: [
        AUTH_HEADERS.X_PETM_ANONYMOUS_KEY,
        AUTH_HEADERS.X_PETM_CUSTOMER_KEY,
        AUTH_HEADERS.X_PETM_CART_ID,
        AUTH_HEADERS.X_PETM_LOYALTY_NUMBER,
    ],
    networkResponseHeaders: ['Set-Cookie'],
    mutationLimit: 100000000,
    mutationBreadcrumbLimit: 100000000,
    minReplayDuration: 1000,
};
